<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">NCR Detail - Dashboard View</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">NCR Number</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.ncrNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Reported Date</label>
                <flat-pickr class="form-control" v-model="ncr.ncrDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Member To</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.memberName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Non Conformance Name</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="happened-before">Happened Before</label>
                <input type="checkbox" class="form-control" v-model="ncr.happenedBefore" id="happened-before" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="ncr.description" rows="3" disabled></textarea>
            </div>
        </div>
        <br />
        Root Cause Analysys & Corrective and Preventive Action Internal Data
        <app-datatable :type="'view'" :elements="dtElementsCorrectivePreventiveInternal" :collections="ncr.ncrCorrectivePreventiveInternal"></app-datatable>
        <br /><br />
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ncrUser } from '../../models/ncrUser'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'


export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
            ncr: {...ncrUser},
            dtElementsCorrectivePreventiveInternal: [
              {
                title: 'Action No.',
                column: 'actionNo',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Root Cause Remark',
                column: 'rootCauseRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Type',
                column: 'actionType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Remark',
                column: 'actionRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Work Description',
                column: 'workDescription',
                type: 'text',
                width: 6,
              },
              {
                title: 'Evidence',
                column: 'evidence',
                type: 'link',
                width: 6,
              },
              {
                title: 'Responder Name',
                column: 'picName',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Target Date',
                column: 'targetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
            memberLookup: {
                id: 'member',
                title: 'Member',
                type: 'form',
                apiUrl: 'member-management-list',
                filter: ['memberName', 'departmentName', 'divisionName'],
                fields: [
                    {
                        placeholder: 'Member',
                        width: 12,
                        column: 'memberName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'memberName'
                    },
                    {
                        title: 'Email',
                        column: 'email'
                    },
                    {
                        title: 'Department',
                        column: 'departmentName'
                    },
                    {
                        title: 'Division',
                        column: 'divisionName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'memberId'
                    },
                    {
                        from: 'memberName',
                        to: 'memberName'
                    },
                ]
            },
            conformanceTypeLookup: {
                id: 'conformance-type',
                title: 'Conformance Type',
                type: 'form',
                apiUrl: 'conformance-type-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Non Conformance Type',
                        width: 12,
                        column: 'conformanceTypeName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'conformanceTypeId'
                    },
                    {
                        from: 'name',
                        to: 'conformanceTypeName'
                    },
                ]
          },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ncrApi = api('ncr-dashboard')
            this.ncr = await ncrApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
        finishUpload(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
    }
}
</script>